import { Link } from "react-router-dom";
import { Phone, Mail, MapPin } from "lucide-react";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer
      id="contact"
      data-testid="site-footer"
      className="relative scroll-mt-24 overflow-hidden bg-ink text-cream"
    >
      <div
        aria-hidden
        className="pointer-events-none absolute inset-0 opacity-[0.035] mix-blend-overlay"
        style={{
          backgroundImage:
            "url(\"data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='180' height='180'><filter id='n'><feTurbulence type='fractalNoise' baseFrequency='0.85' numOctaves='2' stitchTiles='stitch'/></filter><rect width='100%' height='100%' filter='url(%23n)'/></svg>\")",
        }}
      />
      <div aria-hidden className="absolute inset-x-0 top-0 h-px bg-gold/50" />

      <div className="relative mx-auto max-w-[1400px] px-6 py-14 md:px-12 md:py-16 lg:px-16">
        <div className="grid grid-cols-1 gap-12 md:grid-cols-12 md:gap-10">
          <div className="flex flex-col md:col-span-5">
            <Link to="/" className="inline-flex items-center" aria-label="Gambit Immobilier — Accueil">
              <img
                src="/brand/logo-gambit-light.svg"
                alt="Gambit Immobilier"
                className="h-[44px] w-auto select-none md:h-[52px]"
                draggable={false}
              />
            </Link>
            <p className="mt-6 max-w-sm font-serif text-[1.0625rem] leading-relaxed text-cream/70">
              Acquisition · Valorisation · Investissement.
            </p>
            <img
              src="/brand/qr-gambit-immo.png"
              alt="QR code — gambit-immo.fr"
              data-testid="footer-qr-code"
              className="mt-8 h-auto w-[104px] select-none md:mt-auto md:w-[112px]"
              draggable={false}
              loading="lazy"
            />
          </div>

          <div className="md:col-span-4">
            <p className="kicker mb-5 !text-gold">Contact</p>
            <ul className="space-y-3 text-[14px] text-cream/80">
              <li className="font-serif text-[1.0625rem] leading-tight text-cream">
                Farid Amadet
                <span className="mt-0.5 block text-[12px] uppercase tracking-[0.14em] text-cream/60">Président</span>
              </li>
              <li className="flex items-center gap-3">
                <Phone className="h-3.5 w-3.5 text-gold" strokeWidth={1.5} />
                <a href="tel:+33775713978" className="link-quiet hover:text-gold">07 75 71 39 78</a>
              </li>
              <li className="flex items-center gap-3">
                <Mail className="h-3.5 w-3.5 text-gold" strokeWidth={1.5} />
                <a href="mailto:f.amadet@gambit-immo.fr" className="link-quiet hover:text-gold">
                  f.amadet@gambit-immo.fr
                </a>
              </li>
              <li className="flex items-start gap-3 text-cream/60">
                <MapPin className="mt-1 h-3.5 w-3.5 shrink-0 text-gold" strokeWidth={1.5} />
                <span>552 avenue de la plage, 40440 Ondres</span>
              </li>
            </ul>
          </div>

          <div className="md:col-span-3">
            <p className="kicker mb-5 !text-gold">Pages</p>
            <ul className="space-y-3 text-[14px] text-cream/80">
              <li>
                <Link to="/" className="link-quiet hover:text-gold" data-testid="footer-link-home">Accueil</Link>
              </li>
              <li>
                <Link to="/approche" className="link-quiet hover:text-gold" data-testid="footer-link-approche">
                  Notre approche
                </Link>
              </li>
              <li>
                <Link to="/mentions-legales" className="link-quiet hover:text-gold" data-testid="footer-link-mentions">
                  Mentions légales
                </Link>
              </li>
              <li>
                <Link to="/politique-de-confidentialite" className="link-quiet hover:text-gold" data-testid="footer-link-confidentialite">
                  Politique de confidentialité
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 h-px w-full bg-cream/10" />
        <div className="mt-5 flex flex-col items-start justify-between gap-2 text-[11px] tracking-[0.08em] text-cream/40 md:flex-row md:items-center">
          <span>© {year} Gambit Immobilier. Tous droits réservés.</span>
          <span className="uppercase tracking-[0.18em]">Acquisition · Valorisation · Investissement</span>
        </div>
      </div>
    </footer>
  );
}
